import React, { createContext, useContext, useState, useCallback } from 'react';

const BomThemeContext = createContext({ theme: 'light', toggleTheme: () => {} });

const STORAGE_KEY = 'bom-editor-theme';

export const BomThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || 'light'; }
    catch { return 'light'; }
  });

  const toggleTheme = useCallback(() => {
    setTheme(prev => {
      const next = prev === 'dark' ? 'light' : 'dark';
      try { localStorage.setItem(STORAGE_KEY, next); } catch {}
      return next;
    });
  }, []);

  return (
    <BomThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </BomThemeContext.Provider>
  );
};

export const useBomTheme = () => useContext(BomThemeContext);
